/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "../src/assets/js/main.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "../src/assets/js/main.js":
/*!********************************!*\
  !*** ../src/assets/js/main.js ***!
  \********************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* harmony import */ var _modules_clickEvents__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/clickEvents */ "../src/assets/js/modules/clickEvents.js");
  /* harmony import */ var _modules_clickEvents__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_modules_clickEvents__WEBPACK_IMPORTED_MODULE_0__);
  /* harmony import */ var _modules_handleFixedHeader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/handleFixedHeader */ "../src/assets/js/modules/handleFixedHeader.js");
  /* harmony import */ var _modules_handleFixedHeader__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_modules_handleFixedHeader__WEBPACK_IMPORTED_MODULE_1__);
  /* harmony import */ var _modules_slider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/slider */ "../src/assets/js/modules/slider.js");
  /* harmony import */ var _modules_slider__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_modules_slider__WEBPACK_IMPORTED_MODULE_2__);
  /* harmony import */ var _modules_paralax__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/paralax */ "../src/assets/js/modules/paralax.js");
  /* harmony import */ var _modules_paralax__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_modules_paralax__WEBPACK_IMPORTED_MODULE_3__);
  /* harmony import */ var _modules_video__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./modules/video */ "../src/assets/js/modules/video.js");
  /* harmony import */ var _modules_video__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_modules_video__WEBPACK_IMPORTED_MODULE_4__);
  /* harmony import */ var _modules_stickyNav__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./modules/stickyNav */ "../src/assets/js/modules/stickyNav.js");
  /* harmony import */ var _modules_stickyNav__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_modules_stickyNav__WEBPACK_IMPORTED_MODULE_5__);
  /* harmony import */ var _modules_accordion_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./modules/accordion.js */ "../src/assets/js/modules/accordion.js");
  /* harmony import */ var _modules_handleCheckboxes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./modules/handleCheckboxes */ "../src/assets/js/modules/handleCheckboxes.js");
  /* harmony import */ var _modules_handleCheckboxes__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_modules_handleCheckboxes__WEBPACK_IMPORTED_MODULE_7__);
  /* harmony import */ var _modules_shopify__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./modules/shopify */ "../src/assets/js/modules/shopify.js");
  /* harmony import */ var _modules_shopify__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_modules_shopify__WEBPACK_IMPORTED_MODULE_8__);
  
  
  
  
  
  
  
  
  
  
  /***/ }),
  
  /***/ "../src/assets/js/modules/accordion.js":
  /*!*********************************************!*\
    !*** ../src/assets/js/modules/accordion.js ***!
    \*********************************************/
  /*! no exports provided */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var _utils_globals_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/globals.js */ "../src/assets/js/utils/globals.js");
  
  var mobileQuery = window.matchMedia("(max-width: 767px), screen and (max-width: 812px) and (orientation: landscape)");
  $('.js-accordion-trigger').on('click', function (event) {
    event.preventDefault();
    var $this = $(this);
    var $currentSection = $this.closest('.js-accordion');
    var $nextSection = $this.closest('.js-accordion').next();
  
    if (mobileQuery.matches) {
      $this.siblings('.js-accordion-content').slideToggle(0);
      $this.toggleClass('open');
      $currentSection.toggleClass('open');
  
      if ($currentSection.hasClass('section-review')) {
        if ($currentSection.hasClass('open')) {
          $currentSection.css('background-color', '');
        } else {
          $currentSection.css('background-color', '#fff');
        }
      }
  
      if ($nextSection.hasClass('js-accordion-content')) {
        $nextSection.slideToggle(0);
      }
  
      $currentSection.find('.js-slider .slider__slides').slick('refresh');
      $currentSection.find('.slick-slider').slick('refresh');
    }
  });
  $(window).on('load resize', function (event) {
    event.preventDefault();
  
    if (!mobileQuery.matches) {
      $(document).find('.section--accordion').css('display', '');
      $(document).find('.section-review').css('background-color', '');
    } else {
      $('.section-review').css('background-color', '#fff');
    }
  });
  $('.js-accordion .accordion__head').on('click', function (e) {
    var $this = $(this);
    $this.toggleClass('is-active');
    $this.parent().siblings().find('.accordion__head');
    $this.next().stop(true, true).slideToggle().parent().toggleClass('is-active');
    e.preventDefault();
  });
  /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "jquery")))
  
  /***/ }),
  
  /***/ "../src/assets/js/modules/clickEvents.js":
  /*!***********************************************!*\
    !*** ../src/assets/js/modules/clickEvents.js ***!
    \***********************************************/
  /*! no static exports found */
  /***/ (function(module, exports, __webpack_require__) {
  
  /* WEBPACK VAR INJECTION */(function($) {$('.js-product-btn').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    $this.parent().addClass('hidden');
    $('.js-products').addClass('is-visible');
  });
  var $body = $('body');
  $('.js-link').on('click', function (e) {
    e.preventDefault();
    var $target = $(this).attr('href');
    $($target).toggleClass('is-active');
  
    if ($($target).hasClass('js-popup')) {
      $body.toggleClass('is-popup-open');
    }
  });
  $('.js-popup-link').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $target = $this.attr('href');
    $this.parent().addClass('is-active');
    $('.form-popup').removeClass('is-active');
    $('.js-tab-secondary').removeClass('is-active');
    $($target).addClass('is-active');
    $this.parent().siblings().removeClass('is-active');
  });
  $(window).on('click', function (e) {
    var popup = $('.popup')[0];
    var mobileMenu = $('.mobile-menu')[0];
    var $menu = $('.menu');
  
    if (e.target == popup) {
      $('.popup').removeClass('is-active');
    }
  
    $menu.each(function (index, el) {
      if (e.target == el || e.target == mobileMenu) {
        $('.menu').removeClass('is-active');
        $('.mobile-menu').removeClass('is-active');
        $('.burger-btn').removeClass('is-active');
        $('.header').removeClass('is-white');
      }
    });
  });
  $('.js-burger').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $header = $('.header');
    var $bar = $('.bar');
    var $barHeight = $bar.outerHeight();
    var $headerHeight = $header.outerHeight();
    var $menuTop = $barHeight + $headerHeight;
    $('.mobile-menu').css('top', $menuTop);
    $this.toggleClass('is-active');
    $('.mobile-menu').toggleClass('is-active');
    $header.toggleClass('is-white');
    $('body').toggleClass('is-menu-open');
    $('.menu').removeClass('is-active');
  
    if ($(window).scrollTop() > $barHeight) {
      $('.mobile-menu').css('top', $headerHeight);
    }
  });
  $('.js-mobile-accordion').on('click', function (e) {
    if ($(window).width() <= 767) {
      e.preventDefault();
      var $this = $(this);
      $this.toggleClass('is-active');
      $this.next().stop(true, true).slideToggle();
      $this.parent().siblings().find('.section__content-body').slideUp();
      $this.parent().siblings().find('.section__content-head').removeClass('is-active');
    }
  });
  $('.js-toggle-dropdown').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    $this.next().toggleClass('is-active');
    $this.parent().siblings().find('.menu').removeClass('is-active');
  });
  $('.js-link-more').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $target = $this.attr('href');
    var $text = $this.data('text');
    $this.toggleClass('is-more');
  
    if ($this.hasClass('is-more')) {
      $this.text('Close');
      $($target).slideDown();
    } else {
      $this.text($text);
      $($target).slideUp();
    }
  });
  $('.js-btns a').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $target = $this.attr('href');
    var $images = $('.js-media .js-content');
    $images.removeClass('is-active');
    $($target).addClass('is-active');
    var $players = $('.player');
    $players.each(function (i, el) {
      var $this = $(this);
      $this[0].pause();
    });
  });
  $('.play-btn').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    $this.parent().addClass('is-hidden');
    $this.parent().find('.player')[0].play();
  });
  $('.js-radios .radio input').on('change', function () {
    $('#' + $(this).data('image')).addClass('is-visible').siblings().removeClass('is-visible');
  });
  $('.js-search .search__field').on('focus', function (e) {
    e.preventDefault();
    $(this).closest('.js-search').addClass('is-active');
  });
  $('.js-close-search').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.js-search').removeClass('is-active');
  });
  /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "jquery")))
  
  /***/ }),
  
  /***/ "../src/assets/js/modules/handleCheckboxes.js":
  /*!****************************************************!*\
    !*** ../src/assets/js/modules/handleCheckboxes.js ***!
    \****************************************************/
  /*! no static exports found */
  /***/ (function(module, exports, __webpack_require__) {
  
  /* WEBPACK VAR INJECTION */(function($) {function handleCheckboxes() {
    var $form = $('.js-form');
    var $checkboxes = $form.find('.js-checkbox');
    var isChecked;
    var isAllChecked;
    $checkboxes.each(function (index, checkbox) {
      var $this = $(this);
  
      if ($this.find('[type=checkbox]').is(':checked')) {
        isChecked = true;
      }
  
      if (!$this.find('[type=checkbox]').is(':checked')) {
        isChecked = false;
        isAllChecked = false;
      }
    });
  
    if (isAllChecked != false) {
      $form.addClass('checkbox-is-checked');
    } else {
      $form.removeClass('checkbox-is-checked');
    }
  }
  
  $('.js-checkbox [type=checkbox]').on('click', function (e) {
    handleCheckboxes();
  });
  $(window).on('load', function (e) {
    handleCheckboxes();
  });
  /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "jquery")))
  
  /***/ }),
  
  /***/ "../src/assets/js/modules/handleFixedHeader.js":
  /*!*****************************************************!*\
    !*** ../src/assets/js/modules/handleFixedHeader.js ***!
    \*****************************************************/
  /*! no static exports found */
  /***/ (function(module, exports, __webpack_require__) {
  
  /* WEBPACK VAR INJECTION */(function($) {var $headerHeightBeforeScroll = $('.header').outerHeight();
  
  function positionHeaderAndMenu() {
    var $header = $('.header');
    var $bar = $('.bar');
    var $barHeight = $bar.outerHeight();
    var $headerHeight = $header.outerHeight();
    var $menuTop = 0;
  
    if ($bar.length) {
      $menuTop = $barHeight + $headerHeight;
      $header.css('top', $barHeight);
    } else {
      $menuTop = $headerHeight;
      $header.css('top', 0);
    }
  
    $('.menu').css('top', $menuTop);
    $header.css('min-height', $headerHeightBeforeScroll);
    var $mobileMenu = $('.mobile-menu .nav').outerHeight();
  
    if ($(window).width() <= 767) {
      $('.menu').css('top', $menuTop + $mobileMenu);
      $('.mobile-menu').css('top', $menuTop);
    }
  
    if ($(window).scrollTop() >= $barHeight) {
      $header.css('top', '0');
    }
  }
  
  function toggleClassHeader() {
    var $header = $('.header');
    var $bar = $('.bar');
    var $barHeight = $bar.outerHeight();
    var $headerHeight = $header.outerHeight();
    var $mobileMenu = $('.mobile-menu .nav').outerHeight();
    var $menuTop = 0;
  
    if ($bar.length) {
      $menuTop = $barHeight + $headerHeight;
    } else {
      $menuTop = $headerHeight;
    }
  
    if ($bar.length) {
      if ($(window).scrollTop() > $bar.outerHeight()) {
        $header.addClass('is-fixed');
        $header.css('top', 0);
  
        var _$mobileMenu = $('.mobile-menu .nav').outerHeight();
  
        $('.menu').css('top', $headerHeight);
  
        if ($(window).width() <= 767) {
          $('.menu').css('top', _$mobileMenu + $headerHeight);
          $('.mobile-menu').css('top', $headerHeight);
        }
      } else {
        $header.removeClass('is-fixed');
        $('.menu').css('top', $menuTop);
  
        if ($(window).width() <= 767) {
          $('.menu').css('top', $menuTop + $mobileMenu);
        }
      }
    } else {
      if ($(window).scrollTop() > 0) {
        $header.addClass('is-fixed');
        $header.css('top', 0);
  
        var _$mobileMenu2 = $('.mobile-menu .nav').outerHeight();
  
        $('.menu').css('top', $headerHeight);
  
        if ($(window).width() <= 767) {
          $('.menu').css('top', _$mobileMenu2 + $headerHeight);
          $('.mobile-menu').css('top', $headerHeight);
        }
      } else {
        $header.removeClass('is-fixed');
        $('.menu').css('top', $menuTop);
  
        if ($(window).width() <= 767) {
          $('.menu').css('top', $menuTop + $mobileMenu);
        }
      }
    }
  }
  
  $(window).on('load', function (e) {
    positionHeaderAndMenu();
  });
  $(window).on('scroll', function (e) {
    positionHeaderAndMenu();
    toggleClassHeader();
  });
  $(document).ready(function () {
    $(".field").on('propertychange input', function () {
      var inputVal = $(this).val();
  
      if (inputVal != '') {
        $(this).closest('.form__controls').addClass('is-focused');
      } else {
        $(this).closest('.form__controls').removeClass('is-focused');
      }
    });
  });
  /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "jquery")))
  
  /***/ }),
  
  /***/ "../src/assets/js/modules/paralax.js":
  /*!*******************************************!*\
    !*** ../src/assets/js/modules/paralax.js ***!
    \*******************************************/
  /*! no static exports found */
  /***/ (function(module, exports, __webpack_require__) {
  
  /* WEBPACK VAR INJECTION */(function($) {var $OffsetElements = $('.buble');
  
  function scrollHeightAsVariable() {
    var $scroll = $(window).scrollTop();
    $(':root').css("--scroll-height", $scroll + 'px');
    $OffsetElements.each(function (index, el) {
      var $speed = $(this).data('speed');
      $(this).css("--speed", $speed);
    });
  }
  
  var getOffsetTop = function getOffsetTop() {
    return $OffsetElements.each(function (index, element) {
      var $element = $(element);
      var offsetTop = $element.offset().top;
      $element.css("--offset-top", offsetTop + "px");
    });
  };
  
  $(window).on('load resize', function (e) {
    getOffsetTop();
  });
  $(window).on('scroll', function (e) {
    scrollHeightAsVariable();
  });
  /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "jquery")))
  
  /***/ }),
  
  /***/ "../src/assets/js/modules/shopify.js":
  /*!*******************************************!*\
    !*** ../src/assets/js/modules/shopify.js ***!
    \*******************************************/
  /*! no static exports found */
  /***/ (function(module, exports, __webpack_require__) {
  
  /* WEBPACK VAR INJECTION */(function($) {$('.ajax-add-to-cart').submit(function (e) {
    e.preventDefault();
    var $submitButton = $(this).find('.js-add-to-cart');
    $submitButton.attr('disabled', 'disabled');
    window.ShpCustom.Cart.addItemFromForm($(this).serialize(), function () {
      $submitButton.removeAttr('disabled');
      console.log('addItemFromForm fired')
      if ($submitButton.hasClass('js-close')) {
        $submitButton.closest('.popup__inner').find('.popup__close').click();
      }
    });
  });
  window.ShpCustom = window.ShpCustom || {
    Cart: {}
  };
  
  window.ShpCustom.Cart.onItemAdded = function () {
    window.ShpCustom.Cart.getCart();
  };
  
  window.ShpCustom.Cart.onError = function () {
    console.log('ShpCustom error');
  };
  
  window.ShpCustom.Cart.getCart = function () {
    var params = {
      type: 'GET',
      url: "/cart?view=mini",
      success: function success(lineHtml) {
        if (lineHtml) {
          var jQuerylineHtml = $(lineHtml);
          var cartUpdateCount = jQuerylineHtml.find('#cart_items_count').val();
          var totalPrice = jQuerylineHtml.find('#cart_value_result').val();
          $('#menu-cart').find('.cart__items').replaceWith(jQuerylineHtml);
          $('.js-cart-update-count').text(cartUpdateCount);
          $('.js-cart-update-total').text(totalPrice);
          console.log('jQuerylineHtml', jQuerylineHtml);
          // PageFly product templates disable the main-product section, so those
          // pages render no .js-add-to-cart to read data-container from. Fall
          // back to the drawer itself, which mini-cart.liquid renders on every
          // page, otherwise the item is added but the drawer never opens.
          var container = $('.js-add-to-cart').data('container') || '#menu-cart';
          $(container).addClass('is-active');
          $('body').addClass('no-scroll');
        }
      },
      error: function error(XMLHttpRequest, textStatus) {
        window.ShpCustom.Cart.onError(XMLHttpRequest, textStatus);
      }
    };
    $.ajax(params);
  };
  
  window.ShpCustom.Cart.addItemFromForm = function (data, callback) {
    var params = {
      type: 'POST',
      url: "/cart/add.js",
      data: data,
      dataType: 'json',
      success: function success(lineItem) {
        if (typeof callback === 'function') {
          callback();
        }  
        window.ShpCustom.Cart.onItemAdded(lineItem);
      },
      error: function error(XMLHttpRequest, textStatus) {
        if (typeof callback === 'function') {
          callback();
        }
  
        window.ShpCustom.Cart.onError(XMLHttpRequest, textStatus);
      }
    };
    $.ajax(params);
  };
  
  $('#menu-cart').on('click', '.js-less', function (e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).closest('div');
    var currentVal = parseInt(parent.find("input[name=\"".concat(fieldName, "\"]")).val(), 10);
    var currentVariant = parseInt(parent.find("input[name=\"".concat(fieldName, "\"]")).attr('id'), 10);
    var data = {
      quantity: currentVal - 1,
      id: currentVariant
    };
    var params = {
      type: 'POST',
      url: "/cart/change.js",
      data: data,
      dataType: 'json',
      success: function success(lineItem) {
        window.ShpCustom.Cart.getCart();
      },
      error: function error(XMLHttpRequest, textStatus) {
        if (typeof callback === 'function') {
          callback();
        }
  
        window.ShpCustom.Cart.onError(XMLHttpRequest, textStatus);
      }
    };
    $.ajax(params);
  });
  $('#menu-cart').on('click', '.js-plus', function (e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).closest('div');
    var currentVal = parseInt(parent.find("input[name=\"".concat(fieldName, "\"]")).val(), 10);
    var currentVariant = parseInt(parent.find("input[name=\"".concat(fieldName, "\"]")).attr('id'), 10);
    var data = {
      quantity: currentVal + 1,
      id: currentVariant
    };
    var params = {
      type: 'POST',
      url: "/cart/change.js",
      data: data,
      dataType: 'json',
      success: function success(lineItem) {
        window.ShpCustom.Cart.getCart();
      },
      error: function error(XMLHttpRequest, textStatus) {
        if (typeof callback === 'function') {
          callback();
        }
  
        window.ShpCustom.Cart.onError(XMLHttpRequest, textStatus);
      }
    };
    $.ajax(params);
  });
  /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "jquery")))
  
  /***/ }),
  
  /***/ "../src/assets/js/modules/slider.js":
  /*!******************************************!*\
    !*** ../src/assets/js/modules/slider.js ***!
    \******************************************/
  /*! no static exports found */
  /***/ (function(module, exports, __webpack_require__) {
  
  /* WEBPACK VAR INJECTION */(function($) {function initMobileSliders(argument) {
    $('.js-slider-mobile').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      adaptiveHeight: true
    });
    $('.js-slider-mobile-team').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      dots: false
    });
    $('.js-slider-mobile-applications').slick({
      slidesToShow: 1.1,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      dots: false
    });
  }
  
  function initSlidersDesktop() {
    $('.js-slider .slider__slides').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      dots: false,
      responsive: [{
        breakpoint: 1023,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: 512,
        settings: {
          slidesToShow: 1
        }
      }]
    });
    $('.js-slider-testimonials .slider__slides').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      dots: false,
      responsive: [{
        breakpoint: 1023,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: 512,
        settings: {
          dots: true,
          slidesToShow: 1
        }
      }]
    });
    $('.js-slider-hero .slider__slides').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: false,
      infinite: true,
      dots: false
    });
    $('.js-slider-no-arrows .slider__slides').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      dots: false,
      responsive: [{
        breakpoint: 1023,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: 512,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 1
        }
      }]
    });
    $('.js-slider-days .slider__slides').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      infinite: false,
      dots: true
    });
    $('.js-slider-tiles .slider__slides').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      infinite: false,
      dots: true,
      appendDots: $('.slider__dots')
    });
    $('.js-slider-damage .slider__slides').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      infinite: false,
      dots: true
    });
  }
  
  function refreshSliders() {
    $('.js-slider .slider__slides').slick("refresh");
  }
  
  var mobileQuery = window.matchMedia("(max-width: 767px), screen and (max-width: 812px) and (orientation: landscape)");
  $(window).on('load', function (e) {
    initSlidersDesktop();
  
    if ($(window).width() <= 767) {
      initMobileSliders();
    }
  });
  $(window).on('load resize', function (e) {
    if (mobileQuery.matches) {
      refreshSliders();
    }
  });
  /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "jquery")))
  
  /***/ }),
  
  /***/ "../src/assets/js/modules/stickyNav.js":
  /*!*********************************************!*\
    !*** ../src/assets/js/modules/stickyNav.js ***!
    \*********************************************/
  /*! no static exports found */
  /***/ (function(module, exports, __webpack_require__) {
  
  /* WEBPACK VAR INJECTION */(function($) {function stickyNav() {
    var $stickyEl = $('.js-sticky');
    var $stickyElOfsetTop = $stickyEl.offset().top;
    var $headeHeight = $('.header').outerHeight();
    $(':root').css('--header-height', $headeHeight + "px");
    var $sections = $('section');
    var $stickyNav = $stickyEl.outerHeight();
    test = $headeHeight;
  
    if ($(window).scrollTop() >= $stickyElOfsetTop - $headeHeight) {
      $stickyEl.addClass('is-fixed');
    } else {
      $stickyEl.removeClass('is-fixed');
    }
  
    $sections.each(function (index, el) {
      var $section = $(this);
      var $sectionOffSetTop = $section.offset().top;
  
      if ($(window).scrollTop() >= $sectionOffSetTop - ($headeHeight + $stickyNav)) {
        var $curreSectionId = '#' + $section.attr('id');
        var $currentLink = $stickyEl.find("[href='".concat($curreSectionId, "']"));
        $currentLink.parent().addClass('is-active');
        $currentLink.parent().siblings().removeClass('is-active');
      }
    });
  }
                                           
  const titles = document.querySelectorAll('#result h5');
  titles.forEach(title => {
    const index = title.innerHTML.split(" ").findIndex(item => item.toLowerCase() === "CLINICALLY".toLowerCase());
    if(index !== -1) {
      const before = title.innerHTML.split(" ").slice(0, index);
      const after = title.innerHTML.split(" ").slice(index);
      title.innerHTML = [...before, "<br>", ...after].join(" ");
    }
  })

  // Native Javascript code 

  const options = {
    root: document.querySelector('.list-data--secondary .slick-list'),
    rootMargin: '0px',
    threshold: [0, 1]
  }
  const callback = function(entries, observer) {
    entries.forEach(entry => {
      const { isIntersecting, target } = entry;
      if (isIntersecting) {
        const btn = target.querySelector(".plyr__control");
        if (btn) {
          btn.click();
        }
      } else {
        const btn = target.querySelector(".plyr__control");
        if (btn) {
          btn.click();
        }
      }
    })
  };
                                           
  const observer = new IntersectionObserver(callback, options);
  const target = document.querySelectorAll(".list-data--secondary .box__video") 
  target.forEach(tgt => {
    observer.observe(tgt);
  })                                        
                                          
  
                                           
  $(window).on('load scroll', function (e) {
    if ($('.js-sticky').length) {
      stickyNav();
    }
  });
  $('.js-sticky .section__nav ul a').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $target = $this.attr('href');
    var $stickyNav = $('.js-sticky').outerHeight();
    var $headeHeight = 0;
  
    if ($(window).width() <= 812) {
      $headeHeight = 53;
    } else {
      $headeHeight = 60.19;
    }
  
    $this.parent().addClass('is-active');
    $this.parent().siblings().removeClass('is-active');
    var $scrollTo = $($target).offset().top - ($headeHeight + $headeHeight);
    $('html, body').animate({
      scrollTop: $scrollTo
    }, 1000);
  });
  /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "jquery")))
  
  /***/ }),
  
  /***/ "../src/assets/js/modules/video.js":
  /*!*****************************************!*\
    !*** ../src/assets/js/modules/video.js ***!
    \*****************************************/
  /*! no static exports found */
  /***/ (function(module, exports, __webpack_require__) {
  
  /* WEBPACK VAR INJECTION */(function($) {$(window).on('load', function () {
    var $players = $('.player');
    $players.each(function (i, el) {
      var $this = $(this);
      var player = new Plyr($this);
    });
  });
  /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "jquery")))
  
  /***/ }),
  
  /***/ "../src/assets/js/utils/globals.js":
  /*!*****************************************!*\
    !*** ../src/assets/js/utils/globals.js ***!
    \*****************************************/
  /*! exports provided: $window, $document, $body */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  __webpack_require__.r(__webpack_exports__);
  /* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "$window", function() { return $window; });
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "$document", function() { return $document; });
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "$body", function() { return $body; });
  var $window = $(window);
  var $document = $(document);
  var $body = $('body');
  /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "jquery")))
  
  /***/ }),
  
  /***/ "jquery":
  /*!*************************!*\
    !*** external "jQuery" ***!
    \*************************/
  /*! no static exports found */
  /***/ (function(module, exports) {
  
  module.exports = jQuery;
  
  /***/ })
  
  /******/ });

(function() {
  const origFetch = window.fetch;
  window.fetch = async function() {
    const response = await origFetch.apply(this, arguments);
    const url = arguments[0];

    // Detect add-to-cart endpoint. Covers PageFly and app buttons, which post via
    // fetch and so are never seen by the $('.ajax-add-to-cart').submit handler.
    if (typeof url === 'string' && url.includes('/cart/add.js')) {
      // Clone response so we can read it
      const cloned = response.clone();
      cloned.json().then(data => {
        // getCart() is the theme's own refresh-and-open routine: it repaints
        // #menu-cart, updates the count, and uses addClass -- so unlike a click
        // on the header button (toggleClass) it can never close an open cart.
        window.ShpCustom.Cart.getCart();
      });
    }

    return response;
  };
})();
